// eslint-disable-next-line import/no-extraneous-dependencies
import { FuroDataTextInput } from '@furo/data-input/src/furo-data-text-input.js';

export class FormString extends FuroDataTextInput {}

window.customElements.define('form-string', FormString);
